import { Actor } from 'Core_Games/Actor/Actor';
import { wheelchairWomanAssetConfig } from './wheelchairWomanConfig';

export class WheelchairWoman extends Actor {
  constructor(scene, x, y, color, petType, originalScale, frame) {
    let currentConfig = wheelchairWomanAssetConfig;
    super(scene, x, y, currentConfig, currentConfig.NAME, frame);

    this.spriteName = this.ObjectData.NAME;
    this.Inventory = this.ObjectData.INVENTORY;
    this.Sounds = this.ObjectData.AUDIO;
    this.chatBubbleCoordinatesPercentage = this.ObjectData.CHATBUBBLECOORDINATES;

    this.currentSpriteSheet = color;
    this.originalScale = this.ObjectData.SCALE;
  }
}
